// Generated by Melange

import * as Caml from "melange.js/caml.js";
import * as Caml_int64 from "melange.js/caml_int64.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin__Infix from "./infix.js";
import * as Ocaml_protoc_plugin__Result from "./result.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__BytesLabels from "melange/bytesLabels.js";
import * as Stdlib__ListLabels from "melange/listLabels.js";
import * as Stdlib__Printf from "melange/printf.js";

function create(offsetOpt, length, data) {
  const offset = offsetOpt !== undefined ? offsetOpt : 0;
  const end_offset = length !== undefined ? offset + length | 0 : data.length;
  if (end_offset < offset) {
    throw new Caml_js_exceptions.MelangeError("Assert_failure", {
          MEL_EXN_ID: "Assert_failure",
          _1: [
            "vendored/ocaml_protoc_plugin/reader.ml",
            16,
            2
          ]
        });
  }
  if (data.length < end_offset) {
    throw new Caml_js_exceptions.MelangeError("Assert_failure", {
          MEL_EXN_ID: "Assert_failure",
          _1: [
            "vendored/ocaml_protoc_plugin/reader.ml",
            17,
            2
          ]
        });
  }
  return {
    offset: offset,
    end_offset: end_offset,
    data: data
  };
}

function reset(t, offset) {
  t.offset = offset;
}

function offset(param) {
  return param.offset;
}

function has_more(t) {
  return t.offset < t.end_offset;
}

function read_varint(t) {
  let _acc = Caml_int64.zero;
  let _bit = 0;
  while (true) {
    const bit = _bit;
    const acc = _acc;
    let tmp;
    if (t.offset < t.end_offset) {
      const v = t.data.charCodeAt(t.offset);
      t.offset = t.offset + 1 | 0;
      tmp = v;
    } else {
      tmp = Ocaml_protoc_plugin__Result.raise("Premature_end_of_input");
    }
    const v$1 = Caml_int64.of_int32(tmp);
    const acc$1 = Ocaml_protoc_plugin__Infix.Int64.lor(acc, Ocaml_protoc_plugin__Infix.Int64.lsl(Ocaml_protoc_plugin__Infix.Int64.land(v$1, [
      0,
      127
    ]), bit));
    if (!Caml.i64_eq(Ocaml_protoc_plugin__Infix.Int64.land(v$1, [
        0,
        128
      ]), [
        0,
        128
      ])) {
      return acc$1;
    }
    _bit = bit + 7 | 0;
    _acc = acc$1;
    continue;
  };
}

function read_varint_unboxed(t) {
  return Caml_int64.to_int32(read_varint(t));
}

function read_fixed32(t) {
  if ((t.offset + 4 | 0) <= t.end_offset) {
    
  } else {
    Ocaml_protoc_plugin__Result.raise("Premature_end_of_input");
  }
  const v = Stdlib__BytesLabels.get_int32_le(Stdlib__BytesLabels.unsafe_of_string(t.data), t.offset);
  t.offset = t.offset + 4 | 0;
  return v;
}

function read_fixed64(t) {
  if ((t.offset + 8 | 0) <= t.end_offset) {
    
  } else {
    Ocaml_protoc_plugin__Result.raise("Premature_end_of_input");
  }
  const v = Stdlib__BytesLabels.get_int64_le(Stdlib__BytesLabels.unsafe_of_string(t.data), t.offset);
  t.offset = t.offset + 8 | 0;
  return v;
}

function read_length_delimited(t) {
  const length = Caml_int64.to_int32(read_varint(t));
  if ((t.offset + length | 0) <= t.end_offset) {
    
  } else {
    Ocaml_protoc_plugin__Result.raise("Premature_end_of_input");
  }
  const v_offset = t.offset;
  const v_data = t.data;
  const v = {
    offset: v_offset,
    length: length,
    data: v_data
  };
  t.offset = t.offset + length | 0;
  return v;
}

function read_field_header(t) {
  const v = Caml_int64.to_int32(read_varint(t));
  const match = v & 7;
  let tpe;
  let exit = 0;
  switch (match) {
    case 0 :
      tpe = /* Varint */ 0;
      break;
    case 1 :
      tpe = /* Fixed64 */ 1;
      break;
    case 2 :
      tpe = /* Length_delimited */ 3;
      break;
    case 5 :
      tpe = /* Fixed32 */ 2;
      break;
    default:
      exit = 1;
  }
  if (exit === 1) {
    tpe = Stdlib.failwith(Curry._1(Stdlib__Printf.sprintf({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* String_literal */ 11,
        _0: "Illegal field header: 0x",
        _1: {
          TAG: /* Int */ 4,
          _0: /* Int_x */ 6,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: /* End_of_format */ 0
        }
      },
      _1: "Illegal field header: 0x%x"
    }), v));
  }
  const field_number = v / 8 | 0;
  return [
    tpe,
    field_number
  ];
}

function read_field_content(param) {
  switch (param) {
    case /* Varint */ 0 :
      return function (r) {
        return {
          TAG: /* Varint */ 0,
          _0: read_varint(r)
        };
      };
    case /* Fixed64 */ 1 :
      return function (r) {
        return {
          TAG: /* Fixed_64_bit */ 2,
          _0: read_fixed64(r)
        };
      };
    case /* Fixed32 */ 2 :
      return function (r) {
        return {
          TAG: /* Fixed_32_bit */ 4,
          _0: read_fixed32(r)
        };
      };
    case /* Length_delimited */ 3 :
      return function (r) {
        return {
          TAG: /* Length_delimited */ 3,
          _0: read_length_delimited(r)
        };
      };
  }
}

function next_field_header(reader) {
  if (reader.offset < reader.end_offset) {
    return read_field_header(reader);
  }
  
}

function read_field(t) {
  const match = read_field_header(t);
  const field = read_field_content(match[0])(t);
  return [
    match[1],
    field
  ];
}

function next(t, param) {
  if (t.offset < t.end_offset) {
    return {
      TAG: /* Cons */ 0,
      _0: read_field(t),
      _1: (function (param) {
        return next(t, param);
      })
    };
  } else {
    return /* Nil */ 0;
  }
}

function to_list(t) {
  return Stdlib__ListLabels.of_seq(function (param) {
    return next(t, param);
  });
}

export {
  create,
  offset,
  reset,
  read_field_header,
  read_field_content,
  has_more,
  to_list,
  read_length_delimited,
  read_fixed32,
  read_fixed64,
  read_varint,
  read_varint_unboxed,
  next_field_header,
}
/* Ocaml_protoc_plugin__Result Not a pure module */
